// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { Analytics, getAnalytics, logEvent } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjrknEKILQs2mDeCzznfcTosD_cJrv1_w",
  authDomain: "fable-409311.firebaseapp.com",
  projectId: "fable-409311",
  storageBucket: "fable-409311.firebasestorage.app",
  messagingSenderId: "745555583640",
  appId: "1:745555583640:web:d2729bf55cb0a9a69fe6ed",
  measurementId: "G-885N6MLZ1D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Analytics only in browser environment
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}


// Analytics helper functions
export const trackDownloadEvent = (platform: 'ios' | 'android' | 'onelink', location: string) => {
  if (!analytics) return;
  logEvent(analytics, `download_button_click_${location}_${platform}`, {
    platform,
    location,
    timestamp: new Date().toISOString()
  });
};

export const trackSwiperInteraction = (swiperType: 'voice' | 'story', action: 'click' | 'slide_change', itemIndex?: number, itemName?: string) => {
  if (!analytics) return;
  logEvent(analytics, 'swiper_interaction', {
    swiper_type: swiperType,
    action,
    item_index: itemIndex,
    item_name: itemName,
    timestamp: new Date().toISOString()
  });
};

export const trackVoicePlayEvent = (voiceName: string, voiceTone: string) => {
  if (!analytics) return;
  logEvent(analytics, 'voice_play', {
    voice_name: voiceName,
    voice_tone: voiceTone,
    timestamp: new Date().toISOString()
  });
};

export const trackStoryClickEvent = (storyTitle: string, storyIndex: number) => {
  if (!analytics) return;
  logEvent(analytics, 'story_click', {
    story_title: storyTitle,
    story_index: storyIndex,
    timestamp: new Date().toISOString()
  });
};

export const trackSocialMediaClick = (platform: string) => {
  if (!analytics) return;
  logEvent(analytics, 'social_media_click', {
    platform,
    timestamp: new Date().toISOString()
  });
};

export const trackFAQQuestionClick = (questionText: string, questionIndex: number, anchorId: string) => {
  if (!analytics) return;
  logEvent(analytics, 'faq_question_click', {
    question_text: questionText,
    question_index: questionIndex,
    anchor_id: anchorId,
    timestamp: new Date().toISOString()
  });
};

export { analytics };
export default app; 
